import { useTour } from "@reactour/tour";
import { Col, Divider, Row, Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { Card } from "shared/components";
import metricsPt from "shared/assets/images/metrics-pt.jpg";
import metricsEn from "shared/assets/images/metrics-en.jpg";
import metricsEs from "shared/assets/images/metrics-es.jpg";

const informationByLanguage = {
  pt: {
    metrics: metricsPt,
    tutorialUrl:
      "https://www.youtube.com/embed/-ybsf4i99WE?si=6Y-f3YVNbrS0ZvKS",
  },
  en: {
    metrics: metricsEn,
    tutorialUrl:
      "https://www.youtube.com/embed/hvzGBE0RPwA?si=6Y-f3YVNbrS0ZvKS",
  },
  es: {
    metrics: metricsEs,
    tutorialUrl:
      "https://www.youtube.com/embed/hvzGBE0RPwA?si=6Y-f3YVNbrS0ZvKS",
  },
};

const Tutorial: React.FC<RouteComponentProps> = (props) => {
  const { location }: any = props;
  const { t, i18n } = useTranslation("radar");
  const { setIsOpen } = useTour();
  const [showMore, setShowMore] = useState<boolean>(false);

  const { metrics, tutorialUrl } = useMemo(() => {
    const language = ["pt", "en", "es"].includes(i18n?.language)
      ? (i18n.language as keyof typeof informationByLanguage)
      : "pt";

    return informationByLanguage[language];
  }, [i18n.language]);

  useEffect(() => {
    if (location?.state?.tour) {
      setIsOpen(true);
    }
  }, [location, setIsOpen]);
  return (
    <div className="radar">
      <Row justify="center">
        <Col xs={24}>
          <Row style={{ padding: "100px 0 200px 0" }}>
            <Col xs={24}>
              <Typography.Title
                className="texto-centralizado"
                style={{ fontSize: 40 }}
              >
                {t("pages.Radar.titulo")}
              </Typography.Title>
              <div
                className="explicacao texto-centralizado"
                style={{ fontSize: 25 }}
              >
                <Typography.Text>{t("pages.Radar.mensagem")}</Typography.Text>
              </div>

              <div className="diagnostico-preview">
                <iframe
                  width="60%"
                  height="550"
                  src={tutorialUrl}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  style={{ border: 0 }}
                />
              </div>
            </Col>
            <Col xs={24}>
              <Row justify="center">
                <Col xs={12}>
                  <Card style={{ marginTop: 32, padding: 32 }}>
                    <div
                      className="texto-centralizado"
                      style={{ color: "#fff", fontSize: 20 }}
                    >
                      {t("pages.Radar.remakeTour")}
                    </div>
                    <div
                      className="texto-centralizado"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <button
                        className="botao-verde"
                        onClick={() => setIsOpen(true)}
                        style={{ marginTop: 16 }}
                      >
                        {t("pages.Radar.yes")}
                      </button>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col xs={24}>
              <Row justify="center">
                <img
                  src={metrics}
                  style={{ marginTop: 32 }}
                  width="80%"
                  alt="Gráfico o código Strm"
                />
              </Row>
            </Col>
            <Col xs={24}>
              <Row justify="center">
                <Col xs={20}>
                  <Card style={{ padding: 32, marginTop: 72 }}>
                    <h1 className="texto-colorido">
                      {t("pages.Radar.glossary")}
                    </h1>
                    <Divider style={{ backgroundColor: "#E0E2E7" }} />
                    <div className="glossary-text">
                      <h2>{t("pages.Radar.audioFeatures")}</h2>
                      <span style={{ display: "block", marginTop: 16 }}>
                        {t("pages.Radar.audioFeaturesExplaination")}
                      </span>
                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.danceability")} -</b>{" "}
                        {t("pages.Radar.danceabilityExplanation")}
                      </span>
                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.energy")} -</b>{" "}
                        {t("pages.Radar.energyExplanation")}
                      </span>
                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.speechiness")} -</b>{" "}
                        {t("pages.Radar.speechinessExplanation")}
                      </span>
                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.acousticness")} -</b>{" "}
                        {t("pages.Radar.acousticnessExplanation")}
                      </span>
                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.instrumentalness")} -</b>{" "}
                        {t("pages.Radar.instrumentalnessExplanation")}
                      </span>
                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.liveness")} -</b>{" "}
                        {t("pages.Radar.livenessExplanation")}
                      </span>
                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.valence")} -</b>{" "}
                        {t("pages.Radar.valenceExplanation")}
                      </span>
                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.tempo")} -</b>{" "}
                        {t("pages.Radar.tempoExplanation")}
                      </span>
                    </div>
                    <div className="glossary-text">
                      <h2>{t("pages.Radar.careerStage")}</h2>
                      <span>{t("pages.Radar.careerStageExplaination")}</span>
                      <span
                        className="texto-colorido"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowMore(!showMore)}
                      >
                        {t("pages.Radar.knowMore")}
                      </span>
                      {showMore && (
                        <div style={{ marginLeft: 16 }}>
                          <h1 style={{ color: "#fff", fontSize: 36 }}>
                            {t("pages.Radar.stages")}
                          </h1>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.enthusiastic")}</h2>
                            <span>{t("pages.Radar.enthusiasticText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.aspirant")}</h2>
                            <span>{t("pages.Radar.aspirantText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.experiment")}</h2>
                            <span>{t("pages.Radar.experimentText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.emerging")}</h2>
                            <span>{t("pages.Radar.emergingText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.promise")}</h2>
                            <span>{t("pages.Radar.promiseText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.sustainable")}</h2>
                            <span>{t("pages.Radar.sustainableText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.localSuccess")}</h2>
                            <span>{t("pages.Radar.localSuccessText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.regionalSuccess")}</h2>
                            <span>{t("pages.Radar.regionalSuccessText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.nationalSuccess")}</h2>
                            <span>{t("pages.Radar.nationalSuccessText")}</span>
                          </div>
                          <div className="glossary-text">
                            <h2>{t("pages.Radar.internationalSuccess")}</h2>
                            <span>
                              {t("pages.Radar.internationalSuccessText")}
                            </span>
                          </div>
                          {/* <div className="glossary-text">
                            <h2>{t("pages.Radar.icon")}</h2>
                            <span>{t("pages.Radar.iconText")}</span>
                          </div> */}
                        </div>
                      )}
                    </div>

                    <div className="glossary-text">
                      <h2>{t("pages.Radar.metrics")}</h2>
                      <span>{t("pages.Radar.metricsExplaination")}</span>

                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.performance")} - </b>
                        {t("pages.Radar.performanceExplaination")}
                      </span>

                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.development")} - </b>
                        {t("pages.Radar.developmentExplaination")}
                      </span>

                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.music")} - </b>
                        {t("pages.Radar.musicExplaination")}
                      </span>

                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.image")} - </b>
                        {t("pages.Radar.imageExplaination")}
                      </span>

                      <span style={{ display: "block", marginTop: 16 }}>
                        <b>{t("pages.Radar.stability")} - </b>
                        {t("pages.Radar.stabilityExplaination")}
                      </span>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Tutorial;
